/**
 * @module
 * @name FNOL
 * @description Application in FNOL mode will be embedded in a frame. There are
 *              many params passed through params in the URL.
 */

const QueryString = new URLSearchParams(window.location.search)
const user = QueryString.get('user')
const token = QueryString.get('token')
const isExternalAuth = QueryString.get('is_external_auth')
const refSin = QueryString.get('ref_sin')
const addressSin = QueryString.get('address_sin')
const addressLatSin = QueryString.get('address_lat_sin')
const addressLngSin = QueryString.get('address_lng_sin')
const addressPostcodeSin = QueryString.get('address_postcode_sin')
const moreThanTwoYears = QueryString.get('more_than_two_years')
const realEstate = QueryString.get('real_estate')
const userType = QueryString.get('user_type')
const refEvt = QueryString.get('ref_evt')
const warrantyId = QueryString.get('warranty_id')
const warrantySubtypeId = QueryString.get('warranty_subtype_id')
const hideRef = QueryString.get('hide_ref')
const closeAccordions = QueryString.get('close_accordions')
const hideSummary = QueryString.get('hide_summary')
const externalDamageId = QueryString.get('external_damage_id')

function inIframe() {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

/**
 * @name FNOLFlow
 * @type {Object}
 * @description This object is used across the app.
 * @property {Boolean} isExecuting True if app is running inside an iframe and
 *                                 has user as query param.
 * @property {Object} params FNOL params
 * @property {String} user Username to be sent for log-in purposes.
 * @property {String} token Login user token which is used as params when autologin.
 * @property {String} refSin Sinister ref, if it doesn't exist, it will be created.
 * @property {String} addressSin Sinister address.
 * @property {String} addressPostcodeSin Sinister address postcode.
 * @property {String} addressLatSin Sinister address latitude.
 * @property {String} addressLngSin Sinister address longitude.
 * @property {Boolean} isExternalAuth Boolean which is used as params when autologin.
 * @property {String} refEvt Sinister seconday ref.
 * @property {String} warrantyId Array of warranty groups identificators that
 *                               will appear in the sidenav. If it's empty, all
 *                               sidenav items will be shown.
 * @property {String} warrantySubtypeId Array of subwarranty groups identificators
 *                                      that will appear in the tabs of each
 *                                      warranty view. If it's empty, all tabs
 *                                      items will be shown.
 * @property {String} hideRef If true, warrantyProps will be hidden.
 * @property {String} closeAccordions If true, warrantyProps and warrantyRef accordion will be closed by default.
 * @property {String} hideSummary If true, damage summary won't be shown when analysing.
 * @property {String} externalDamageId External damage reference provided by external interface by iframe url to
 *                                     associate a specific valoration to an internal damage reference.
 */
const FNOLFlow = {
  isExecuting: inIframe() && user,
  isFNOLPlatform: inIframe() && !token && user,
  isIgnitionPlatform: inIframe() && !!token,
  params: {
    user,
    token,
    isExternalAuth,
    refSin,
    addressSin,
    addressLatSin,
    addressLngSin,
    addressPostcodeSin,
    moreThanTwoYears,
    realEstate,
    userType,
    refEvt,
    warrantyId,
    warrantySubtypeId,
    hideRef,
    closeAccordions,
    hideSummary,
    externalDamageId
  }
}

export default FNOLFlow
